import type { ComponentType, FC } from "react";
import { useEffect } from "react";

import omit from "lodash/omit";

import { getDisplayName } from "app/helpers/react/getDisplayName";

interface PopupContentProps {
    reposition?: VoidFunction;
}

export const withAutoReposition = <T extends {}>(Component: ComponentType<T>): FC<T & PopupContentProps> => {
    const NewComponent: FC<T & PopupContentProps> = (props) => {
        useEffect(() => void props?.reposition?.(), []);
        const newProps = omit(props, "reposition") as T;

        return <Component {...newProps} />;
    };
    NewComponent.displayName = `withAutoReposition(${getDisplayName(Component)})`;

    return NewComponent;
};
